
import config from '../config'

export default function commImageUrl(fileName) {
  let baseUrl = config.baseUrl
  return baseUrl + "getcommodityimage?commodity=" + fileName
}